export const experienceData = [
    {
        id: 1,
        company: 'VoktaKantho',
        jobtitle: 'Website Management',
        startYear: '2021',
        endYear: '2021(october)'
    },
    {
        id: 2,
        company: 'Vokta Ovijog Kendro',
        jobtitle: 'Online Publisher',
        startYear: '2021',
        endYear: '2021(September)'
    },
    {
        id: 3,
        company: 'Webio',
        jobtitle: 'Web developer',
        startYear: '2021(november)',
        endYear: 'Present'
    },
]